module.exports = __webpack_public_path__ + "img/business_img0302.38ec913f.jpg";